export interface Plate {
    image: string;
    pos: string;
    origin: string;
    time?: string;
    food_item: string;
    processing_label: string;
    meal_type: string;
    weight: string;
    score: number;
    calories: string;
    carbohydrates: string;
    refined_carbs: string;
    natural_sugar: string;
    added_sugar: string;
    fiber: string;
    protein: string;
    fat: string;
    sat_fat: string;
    unsaturated_fat: string;
    trans_fat: string;
    sodium: string;
    micronutrient_score: number;
    positives: string[];
    considerations: string[];
}

export const PLATES: Plate[] = [
    {
        image: '/assets/food/berry-bowl.webp',
        pos: 'center',
        origin: 'Brazil · açaí',
        time: '8:05 am',
        food_item: 'Açaí bowl with banana, berries and nut butter',
        processing_label: 'Minimally processed',
        meal_type: 'Breakfast',
        weight: '383 g',
        score: 84,
        calories: '464 kcal',
        carbohydrates: '57 g',
        refined_carbs: '3 g',
        natural_sugar: '31 g',
        added_sugar: '6 g',
        fiber: '13 g',
        protein: '11 g',
        fat: '21 g',
        sat_fat: '3 g',
        unsaturated_fat: '18 g',
        trans_fat: '0 g',
        sodium: '63 mg',
        micronutrient_score: 9,
        positives: [
            '13 g fibre from berries, banana and chia',
            'Anthocyanin-rich açaí and blueberries',
            'Unsaturated fats from the nut butter and seeds',
        ],
        considerations: [
            '31 g of sugar even though most of it is from fruit',
            'Açaí packs often carry about 6 g added sugar',
            'Protein is modest for a full breakfast',
        ],
    },
    {
        image: '/assets/food/biryani.webp',
        pos: 'center',
        origin: 'South Asia',
        time: '9:30 pm',
        food_item: 'Rice with chicken curry and onion raita',
        processing_label: 'Minimally processed',
        meal_type: 'Lunch · dinner',
        weight: '427 g',
        score: 57,
        calories: '587 kcal',
        carbohydrates: '61 g',
        refined_carbs: '49 g',
        natural_sugar: '4 g',
        added_sugar: '0 g',
        fiber: '4 g',
        protein: '32 g',
        fat: '23 g',
        sat_fat: '7 g',
        unsaturated_fat: '16 g',
        trans_fat: '0 g',
        sodium: '811 mg',
        micronutrient_score: 6,
        positives: [
            'Strong complete protein from the chicken curry',
            'Yoghurt raita adds calcium and live cultures',
            'Cooked at home rather than deep fried',
        ],
        considerations: [
            'White rice pushes refined carbs to roughly 49 g',
            'Sodium is high for a single sitting',
            'Only 4 g fibre — a vegetable side would help',
        ],
    },
    {
        image: '/assets/food/meal-4.webp',
        pos: 'center',
        origin: 'India · pulao',
        food_item: 'Vegetable pulao with cashews and curd',
        processing_label: 'Minimally processed',
        meal_type: 'Lunch · dinner',
        weight: '391 g',
        score: 61,
        calories: '613 kcal',
        carbohydrates: '79 g',
        refined_carbs: '61 g',
        natural_sugar: '7 g',
        added_sugar: '0 g',
        fiber: '6 g',
        protein: '17 g',
        fat: '25 g',
        sat_fat: '7 g',
        unsaturated_fat: '18 g',
        trans_fat: '0 g',
        sodium: '687 mg',
        micronutrient_score: 7,
        positives: [
            'Peas, carrot and cauliflower add real vegetable volume',
            'Cashews contribute unsaturated fat and magnesium',
            'Curd on the side brings protein and probiotics',
        ],
        considerations: [
            'Basmati rice makes this a carb-led plate at 79 g',
            'Protein is low relative to the calorie load',
            'Ghee or oil in the pulao lifts total fat to 25 g',
        ],
    },
    {
        image: '/assets/food/rice-bowl.webp',
        pos: 'center 38%',
        origin: 'India · poha',
        food_item: 'Poha with peanuts, peas and curry leaves',
        processing_label: 'Minimally processed',
        meal_type: 'Breakfast',
        weight: '263 g',
        score: 68,
        calories: '381 kcal',
        carbohydrates: '58 g',
        refined_carbs: '44 g',
        natural_sugar: '3 g',
        added_sugar: '0 g',
        fiber: '5 g',
        protein: '9 g',
        fat: '13 g',
        sat_fat: '2 g',
        unsaturated_fat: '11 g',
        trans_fat: '0 g',
        sodium: '592 mg',
        micronutrient_score: 6,
        positives: [
            'Peanuts add unsaturated fat and a protein lift',
            'Turmeric and curry leaves come with no added sugar',
            'Light on calories for a warm cooked breakfast',
        ],
        considerations: [
            'Flattened rice keeps refined carbs around 44 g',
            '9 g protein is low for a first meal',
            'Sodium is moderately high for the portion',
        ],
    },
];
